module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_a01/main_sp_962fb7363d67c4d51ffa3fd03b7e030b.jpg";